import { IconWrapper } from '../runtime';
export default IconWrapper('collect-laptop', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M21 9H11C9.34315 9 8 10.3431 8 12V33H40V23",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M4 33H44V35C44 38.3137 41.3137 41 38 41H10C6.68629 41 4 38.3137 4 35V33Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M32.3 7C30.4775 7 29 8.43473 29 10.2046C29 13.4091 32.9 16.3223 35 17C37.1 16.3223 41 13.4091 41 10.2046C41 8.43473 39.5225 7 37.7 7C36.5839 7 35.5972 7.53804 35 8.3616C34.4028 7.53804 33.4161 7 32.3 7Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/icons/CollectLaptop.js
// module id = null
// module chunks = 